import React from 'react';
import { useAuth } from './AuthContext';
import demoVideo from './assets/introok.mp4';
import HeaderRunwayStyle from './HeaderRunwayStyle';
import FooterRunwayStyle from './FooterRunwayStyle';
import CustomLoginForm from './CustomLoginForm';
import TrendingMediaSection from './TrendingMediaSection';
import './LandingPage.css';

function LandingPage() {
  const { keycloak } = useAuth();

  return (
    <div className="landing-wrapper">
      <HeaderRunwayStyle />

      {/* HERO */}
      <div className="hero-section">
        <video autoPlay muted loop playsInline className="hero-video">
          <source src={demoVideo} type="video/mp4" />
        </video>
        <div className="hero-overlay hero-overlay-split">
          {/* Texte gauche */}
          <div className="hero-left">
            <h1 className="hero-title">
              Créez des Documentaires<br />🌍 Collaboratifs & Narratifs
            </h1>
            <p className="hero-subtitle">
              Une plateforme propulsée par l’IA pour donner vie à vos récits culturels.
            </p>
          </div>

          {/* Formulaire à droite */}
          <div className="hero-right">
            <div className="login-floating-card">
              <CustomLoginForm />
            </div>
          </div>
        </div>
      </div>

      {/* FONCTIONNALITÉS */}
      <section className="features-section container py-5">
  <h2 className="text-center mb-5 fw-bold display-6">✨ Fonctionnalités clés</h2>
  <div className="row g-4 justify-content-center">
    <div className="col-md-4">
      <div className="feature-card text-center p-4">
        <div className="feature-icon mb-3">🧠</div>
        <h4 className="fw-semibold">Génération IA</h4>
        <p className="text-muted">
          Script narratif généré à partir de mots-clés, lieux et thèmes culturels.
        </p>
      </div>
    </div>
    <div className="col-md-4">
      <div className="feature-card text-center p-4">
        <div className="feature-icon mb-3">👥</div>
        <h4 className="fw-semibold">Collaboration</h4>
        <p className="text-muted">
          Invitez des contributeurs à enrichir le projet avec des médias, idées et feedbacks.
        </p>
      </div>
    </div>
    <div className="col-md-4">
      <div className="feature-card text-center p-4">
        <div className="feature-icon mb-3">🎬</div>
        <h4 className="fw-semibold">Montage Assisté</h4>
        <p className="text-muted">
          Montez automatiquement votre vidéo grâce à l’IA et personnalisez-la selon votre vision.
        </p>
      </div>
    </div>
  </div>
</section>

      <TrendingMediaSection />
      {/* CTA */}
     <section className="cta-section text-center px-3 px-sm-5 py-5">
  <h2 className="mb-3 fs-4 fs-md-2">🎞️ Prêt à raconter votre histoire ?</h2>
  <p className="lead">Créez un projet documentaire, invitez vos amis et partagez une vision du monde à travers vos récits.</p>
  <button className="btn btn-dark btn-lg mt-3 w-100 w-sm-auto" onClick={() => keycloak.login()}>
    ✨ Commencer
  </button>
</section>


      <FooterRunwayStyle />
    </div>
  );
}

export default LandingPage;
